import React from "react";
import classNames from "classnames";
import Graph from "./Graph";
import "./index.scss";
import Facade from "@whitecobalt/tungsten/esm/components/Facade";

export interface CheckBoxProps extends React.HTMLProps<HTMLInputElement> {
    type?: "checkbox" | "radio";
    value?: any;
    className?: string;
    inline?: boolean;
    isInvalid?: boolean;
    loading?: boolean;
    options: {
        label: string;
        value: any;
        id?: string;
    }[];
}

interface InputBoxComponent<P> extends React.FunctionComponent<P> {
    Graph: typeof Graph;
}

const CheckBox: InputBoxComponent<CheckBoxProps> = ({
    name,
    value,
    className,
    inline,
    isInvalid,
    options,
    loading,
    ...props
}) => {
    return (
        <div
            className={classNames(
                "input-box",
                { radio: props.type === "radio", inline, 'is-invalid': isInvalid },
                className
            )}
        >
            {options.map((option) => (
                <label key={option.value}>
                    <input
                        {...props}
                        name={name}
                        id={option.id || option.value}
                        value={option.value}
                        checked={
                            props.type === "radio"
                                ? value === option.value
                                : Array.isArray(value) &&
                                  value.includes(option.value)
                        }
                    />
                    <span className="custom"></span>
                    {option.label}
                </label>
            ))}
            {loading && (
                <Facade loading rows={1} padding={false} />
            )}
        </div>
    );
};

CheckBox.Graph = Graph;

CheckBox.defaultProps = {
    inline: true,
    type: "checkbox",
};

export default CheckBox;
